import * as React from 'react';
import StorageBoxStore from './store';
import wrapStore from '../../../../utils/wrap-store';
import cx from 'classnames';
import aos from '@src/utils/aos';
import getLanguageByPath from '@src/utils/locale/getLanguageByPath';
import toWebpImage from '@src/utils/to-webp-image';
const styles = require('./index.less');
const lang = getLanguageByPath() === 'zh-Hant' ? 'tc' : getLanguageByPath();

// 右侧标签轴
const StorageBox = ({ store }) => {
  store.use();
  const scrollContainerRef = React.useRef(null);
  React.useEffect(
    () => {
      // 将滚动容器 ref 传递给 store
      if (scrollContainerRef.current) {
        store.setScrollContainer(scrollContainerRef.current);
      }
      // 组件卸载时执行 store 的销毁逻辑
      return () => {
        store.destroyScrollListener();
      };
    },
    [store]
  );
  return (
    <div className={cx(styles.timelinerightcontainer)} {...(store.isLeftTitleOpen ? aos.FADE_RIGHT() : aos.FADE_LEFT())}>
      {/* 旧事简史 复兴纪元  标题收纳标题 */}
      {store.isLeftTitleOpen ? (
        <div className={cx(styles.righttitle_close)} style={{ backgroundImage: `url(${toWebpImage(require(`./images/${lang}/right-title-close.png`))})` }} />
      ) : (
        <div className={cx(styles.lefttitle_close)} style={{ backgroundImage: `url(${toWebpImage(require(`./images/${lang}/left-title-close.png`))})` }} />
      )}
      {/*  */}
      <div className={styles.rightaxislist} id="storageListBox" ref={scrollContainerRef}>
        {store.data?.map((item, index) => (
          <div
            className={cx({ [styles.rightaxisitem_active]: item.active }, store.isLeftTitleOpen ? styles.rightaxisitem : styles.leftaxisitem)}
            key={index}
            onClick={e => {
              e.stopPropagation();
              store.viewList(index);
            }}
          >
            <span className={styles.righttag}>{item?.title}</span>
            <span className={styles.rightid}>{item?.data}</span>
          </div>
        ))}
      </div>
      <div className={cx(store.isLeftTitleOpen ? styles.LarrowBg : styles.RarrowBg)} onClick={() => store.viewList(0)}>
        <div className={cx(store.isLeftTitleOpen ? styles.Larrow : styles.Rarrow)} />
      </div>
    </div>
  );
};

export default wrapStore(StorageBox, StorageBoxStore);
